export enum DocumentDistributionMode {
  Regular = 0,
  Share = 1,
  Publish = 2,
}
